<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="relative w-full pr-6">
    <div class="flex pr-3">
      <div class="w-10 basis-10 tablet:w-16 tablet:basis-16">
        <p class="text-center leading-6 text-gray-600 tablet:leading-7">
          {{ itemIndex + 1 }}
        </p>
      </div>
      <div class="flex-1">
        <h3
          v-if="itemData.name"
          class="text-h5 tablet:line-clamp-4"
          :class="isOpen && 'mb-3 tablet:mb-5'"
        >
          {{ itemData.name }}
        </h3>
        <div v-if="isOpen">
          <p
            v-if="itemData.description"
            class="element-description mb-2 text-sm leading-6 text-gray-700 last:mb-0 tablet:line-clamp-6"
            v-html="provideSanitized(itemData.description)"
          />
          <TheNuxtLink
            v-if="itemData.link"
            :id="itemData.link.trackingCode"
            :to="itemData.link"
            :title="itemData.link.name"
            class="text-sm font-bold leading-6 text-blue-400 underline"
          >
            {{ itemData.link.name }}
          </TheNuxtLink>
        </div>
      </div>
    </div>
    <button class="absolute right-0 top-0 h-6 w-6" @click="handleClick">
      <IconCaret :direction="isOpen ? 'up' : 'down'" class="h-full w-full" />
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { IItem } from '@/components/Shared/Section/Accordion/02.vue';

  interface IProps {
    itemData: IItem;
    itemIndex: number;
    defaultOpen?: boolean;
  }

  const props = defineProps<IProps>();

  const isOpen = ref<boolean>(props.defaultOpen);

  const handleClick = (): void => {
    isOpen.value = !isOpen.value;
  };
</script>

<style lang="scss" scoped>
  .element-description:deep(a) {
    @apply font-bold text-blue-400 underline;
  }

  .element-description:deep(ul) {
    padding-left: 1.75rem; // 28px
    list-style-type: disc;
  }

  .element-description:deep(ol) {
    padding-left: 1.5rem;
    list-style-type: decimal;
  }
</style>
